import { ErrorHandler, Injectable } from '@angular/core';
import { GlobalErrorService } from './error.service';
import { Response } from '@angular/http';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

  constructor(private errorService: GlobalErrorService) {
  }

  handleError(error) {
    const defaultError = {
      message: 'Errore sconosciuto.',
      notify: true
    };

    console.log("ERROR HANDELER", error);

    if (error instanceof Response) {
      this.processHttpError(error, defaultError);
    }

    if (error.code && error.code === "auth/email-already-in-use") {
      const appError =
      {
        notify: true,
        message: error.message
      }
      this.notify(error, appError);
    } else if (defaultError.notify) {
      this.notify(error, defaultError);
    }
  }

  private notify(error: any, appError: any): void {
    this.errorService.emit(appError);
    console.error(error);
  }

  private processHttpError(error: Response, appError: any): void {
    if (error.status === 401 || error.status === 403) {
      appError.notify = false;

      return;
    }

    try {
      const payload = error.json();
      appError.message = JSON.stringify(payload.message);
      this.notify(error, appError);
    } catch (e) {
      // noop
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/error/error-handler.ts